import { Subscription } from 'rxjs';

/**
 * Clase de utilidad encargada del registro de las suscripciones creadas por componentes/servicios
 * y de su eliminación.
 */
export class SubscriptionUtils {

  /**
 * Lista de suscripciones de la pantalla que seran destruidas automaticamente al eliminar el componente
 */
  protected subscriptions: Array<Subscription>;

  constructor() {
    this.init();
  }

  /**
   * Almacenar suscripción a la lista de suscripciones
   * @param subscription Suscripción a registrar la lista de suscripciones
   */
  public registerSubscription(subscription: Subscription) {
    if (!this.subscriptions) {
      this.subscriptions = [];
    }
    this.subscriptions.push(subscription);
  }

  /**
   * Eliminar las suscripciones registradas
    @param subscription Suscripción a eliminar (unsubscribe) y quitar de la lista de suscripciones
   */
  public unregisterSubscription(subscription: Subscription): void {
    if (this.subscriptions) {
      let finalSubscription = new Array<Subscription>();
      this.subscriptions.forEach((registeredSubscription: Subscription) => {
        if (registeredSubscription === subscription) {
          subscription.unsubscribe();
        } else {
          finalSubscription.push(registeredSubscription);
        }
      });
      this.subscriptions = finalSubscription;
    }
  }

  /**
   * Eliminar todas las suscripciones registradas (unsubscribe) y las quita de la lista de suscripciones registradas
   */
  public unregisterAllSubscriptions(): void {
    if (this.subscriptions) {
      this.subscriptions.filter((subscription: Subscription) => subscription)
        .forEach((subscription: Subscription) => {
          subscription.unsubscribe();
        });
      this.init();
    }
  }


  private init(): void {
    this.subscriptions = new Array<Subscription>();
  }

}
